import { QuotaPayload } from '../../shared/interfaces/quota.interface';
import {
  CombinedQualification,
  SelectedQuota,
} from '../../shared/interfaces/qualification.interface';
import { Constants } from '../../shared/constants/create-survey.constants';

export class AssignQuota {
  constructor(private readonly _quotas: QuotaPayload[]) {}

  public to(qualifications: CombinedQualification[]): CombinedQualification[] {
    const rangeQualifications = new Set<number>(); // store unique qualification indexes

    this._quotas.forEach((quota) => {
      const { index, qualification } = this._find(quota, qualifications);

      if (qualification) {
        qualification.render_type ===
          Constants.QUALIFICATIONS_RENDER_TYPE.RANGE &&
          rangeQualifications.add(index);
        qualification.quotas?.push(quota as SelectedQuota);
        qualification.flexible = quota.flexible;
      }
    });

    if (rangeQualifications.size) {
      rangeQualifications.forEach((qIndex) => {
        qualifications[qIndex].quotas?.unshift({
          minimum: 0,
          maximum: 0,
          number: 0,
          percentage: 0,
        }); // adding empty range for starting row of Quota Modal
      });
    }

    return [...qualifications];
  }

  private _find(quota: QuotaPayload, qualifications: CombinedQualification[]) {
    const index = qualifications.findIndex(
      (q) => q.qualification_code === quota.criteria[0].qualification_code
    );
    return { index, qualification: qualifications[index] };
  }
}
